// extracted by mini-css-extract-plugin
export default {"dashboard":"InsightsScreen_dashboard__4bbg2","data-references":"InsightsScreen_data-references__0yQbS"};